// Lightweight extractors over an analysis result text.
// Mirrors the regex logic used by the backend trends module — no backend / LLM call.

const SOPH_VALUES = ["basico", "intermedio", "avanzado", "experto"];

export function extractSophistication(text) {
  if (!text) return null;
  const m = text.match(
    /NIVEL\s+DE\s+SOFISTICACI[ÓO]N\s+ESTRAT[ÉE]GICA[^\n]*?[:\-]\s*\**\s*([A-Za-záéíóúñÁÉÍÓÚÑ]+)/i
  );
  if (!m) return null;
  const v = m[1].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return SOPH_VALUES.includes(v) ? v : null;
}

const MECHANISMS = [
  { name: "Nosotros vs Ellos", re: /nosotros\s+vs?\.?\s+ellos|polarizaci[oó]n|\bus\s+vs\.?\s+them\b/i },
  { name: "Apelación al miedo", re: /\bmiedo\b|amenaza|peligro|\bfear\b/i },
  { name: "Apelación a la esperanza", re: /\besperanza\b|\bhope\b/i },
  { name: "Apelación a la ira", re: /\bira\b|indignaci[oó]n|\banger\b/i },
  { name: "Apelación al orgullo", re: /\borgullo\b|\bpride\b/i },
  { name: "Eufemismos / elisiones", re: /eufemism|elisi[oó]n|euphemism/i },
  { name: "Vocabulario identitario", re: /identit[aá]ri|identity[- ]activation/i },
];

export function extractDominantMechanism(text) {
  if (!text) return null;
  for (const m of MECHANISMS) {
    if (m.re.test(text)) return m.name;
  }
  return null;
}

const OBJECTIVES = [
  { name: "Consolidar base electoral", re: /consolidar\s+base|consolidate.+base/i },
  { name: "Desmovilizar al adversario", re: /desmoviliz|demobiliz/i },
  { name: "Desviar la atención", re: /desviar\s+la?\s*atenci[oó]n|divert.+attention/i },
  { name: "Construir un enemigo", re: /construir\s+un\s+enemigo|build.+enemy/i },
  { name: "Preparar terreno futuro", re: /preparar\s+terreno|prepare\s+ground/i },
  { name: "Gestionar crisis de reputación", re: /crisis\s+de\s+reputaci[oó]n|reputation\s+crisis/i },
  { name: "Fragmentar a la oposición", re: /fragmentar.+oposici[oó]n|fragment.+opposition/i },
  { name: "Activar voto emocional", re: /voto\s+emocional|emotional\s+vote/i },
];

export function extractPrimaryObjective(text) {
  if (!text) return null;
  const checkedLines = text.split("\n").filter((l) => l.includes("✓"));
  if (checkedLines.length === 0) return null;
  const haystack = checkedLines.join(" | ");
  for (const o of OBJECTIVES) {
    if (o.re.test(haystack)) return o.name;
  }
  return null;
}

export const SOPH_LABEL = {
  basico: "Básico",
  intermedio: "Intermedio",
  avanzado: "Avanzado",
  experto: "Experto",
};

export const SOPH_SCORE = { basico: 1, intermedio: 2, avanzado: 3, experto: 4 };
